export class AssigmentEvaluatorSubject {
  solicitud: number;
  consecutivo: number;
  cedula: String;
}
